export default {
  state: {
    userName: localStorage.getItem("userName") || ""
  },
  actions: {
    setState({ commit }, payload) {
      commit("SET_STATE", payload);
    }
  },
  getters: {
    userName: state => state.userName
  },
  mutations: {
    SET_STATE: (state, payload) => {
      state[payload.stateKey] = payload.state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/common.js